import { msg } from '@lingui/macro';
import getRatingDescriptionSP from 'get-credit-rating-description-sp';
import { MessageDescriptor } from '@lingui/core';
import { useLingui } from '@lingui/react';
import { useCallback } from 'react';
import { AccountPosition } from '../../type';
import { useAccountPositionsTransformApi } from '../api';

type InvestmentGrades = 'Investment grade' | 'High-yield' | 'Not rated';

type GraphData = {
  x: string,
  y: number,
}

const descriptions: Record<InvestmentGrades, MessageDescriptor> = {
  'Investment grade': msg`Investment grade`,
  'High-yield': msg`High-yield`,
  'Not rated': msg`Sans rating`,
};

export const accountPositionsSumPctByRatingSpLoadingValues = (_: (descriptor: MessageDescriptor) => string): GraphData[] => Object.values(descriptions).map((description) => ({
  x: _(description),
  y: 100,
}));

const makeSumPctByRatingSP = (_: (descriptor: MessageDescriptor) => string) => (positions: AccountPosition[] | undefined): GraphData[] => {
  if (!positions) {
    return [];
  }
  return Object.values(positions.reduce((acc, position) => {
    const rating = position['GES_RAT_VAL_SP.SHORTCUT'] || 'NR';
    const ratingDescription: InvestmentGrades = getRatingDescriptionSP.getGradeDescription(rating);
    const translatedRatingDescription = _(descriptions[ratingDescription]);
    return ({
      ...acc,
      [translatedRatingDescription]: {
        x: translatedRatingDescription,
        y: (acc[translatedRatingDescription] || { y: 0 }).y + position['GES_ESTIM_D.PC_PORT_INT'],
      },
    });
  }, {}));
};

export const useAccountPositionsSumPctByRatingSp = () => {
  const {
    _,
  } = useLingui();
  const sumPctByRatingSP = useCallback((positions: AccountPosition[] | undefined) => makeSumPctByRatingSP(_)(positions), [_]);
  const sumPctByRatingSpApiResponse = useAccountPositionsTransformApi({
    transformFunction: sumPctByRatingSP,
  });
  return sumPctByRatingSpApiResponse;
};
